import { CONST } from "../../CONST";
import { GridFillScene } from "../../scenes/GridFillScene";

interface ScoreDisplayConfig{
    scene: GridFillScene,
    position: {x: number, y: number},
}

const CONFIG = {
    textColor: "#ffffff",
    tweenDuration: 300,

}

export class ScoreDisplay extends Phaser.GameObjects.Container{
    private config: ScoreDisplayConfig;

    private scoreText !: Phaser.GameObjects.Text;

    private currentScore: number = 0;

   constructor(config: ScoreDisplayConfig){
       super(config.scene, config.position.x, config.position.y);

        this.config = config;
        this.setScrollFactor(0);

        this.createChildren();

        config.scene.add.existing(this);
    }

    public setScore(score: number){
        let oldScore = this.currentScore;
        this.currentScore = score;

        this.animateScoreChange(oldScore, this.currentScore);
    }

    private animateScoreChange(from: number, to: number){
        let scoreText = this.scoreText;
        this.config.scene.tweens.addCounter({
            from: from,
            to: to,
            duration: CONFIG.tweenDuration,
            onUpdate: function(tween){
                var value = Math.floor(tween.getValue());
                scoreText.text = value.toString();
            }
        });

        this.scene.tweens.add({
            targets: this,
            x: "+=10",
            y: "+=10",
            duration: CONFIG.tweenDuration,
            ease: (t: number) => {return this.wiggle(t, 3, 2)}
        });
    }

    private wiggle(aProgress: number, aPeriod1: number, aPeriod2: number): number {
        var current1: number = aProgress * Math.PI * 2 * aPeriod1;
        var current2: number = aProgress * (Math.PI * 2 * aPeriod2 + Math.PI / 2);

        return Math.sin(current1) * Math.cos(current2);
    }

    private createChildren(){
        this.scoreText = this.config.scene.add.text(0, 0, "0",
        {fontFamily: 'bloggerSans', fontSize: 35, color: CONFIG.textColor, align: 'center' });

        this.add([this.scoreText]);
    }
}